import { StandardEvents } from '@shopify/events';

// Small, non-modal confirmation shown only after a successful Shopify cart add.
(() => {
  const notice = document.getElementById('sw-mini-cart-choice');
  if (!notice || notice.dataset.swChoiceWired) return;
  notice.dataset.swChoiceWired = 'true';

  let generation = 0;
  const hide = () => {
    generation++;
    notice.hidden = true;
  };

  notice.querySelector('[data-sw-cart-continue]')?.addEventListener('click', hide);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !notice.hidden) hide();
  });
  document.addEventListener('theme-drawer:open', event => {
    if (event.target instanceof Element && event.target.id === 'cart-drawer') hide();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted) hide();
  });

  document.addEventListener(StandardEvents.cartLinesUpdate, event => {
    if (event.action !== 'add' || !event.promise || typeof event.promise.then !== 'function') return;
    const current = ++generation;
    const sourceModal = event.target instanceof Element ? event.target.closest('dialog:modal') : null;

    event.promise.then(({ cart, detail }) => {
      if (current !== generation || detail?.didError || !Number.isSafeInteger(cart?.totalQuantity) || cart.totalQuantity < 1) return;
      const reveal = () => {
        if (current !== generation || !notice.isConnected || document.getElementById('cart-drawer')?.hasAttribute('open')) return;
        notice.hidden = false;
      };
      if (sourceModal?.open && sourceModal.matches(':modal')) {
        sourceModal.addEventListener('close', reveal, { once: true });
      } else {
        requestAnimationFrame(reveal);
      }
    }).catch(error => {
      if (current === generation && error?.name !== 'AbortError') {
        console.warn('[sw-mini-cart-choice] Cart addition failed:', error);
      }
    });
  });
})();
